import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  WorkflowQuorumCalculationRequest,
  WorkflowQuorumCalculationResult,
  WorkflowQuorumRules,
} from './workflow-quorum.models';

@Injectable({ providedIn: 'root' })
export class WorkflowQuorumService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);
  private readonly options = {
    withCredentials: true,
    headers: new HttpHeaders({
      'skip-error-interceptor': 'yes',
      'skip-loading-interceptor': 'yes',
    }),
  };

  getRules() {
    return this.http.get<WorkflowQuorumRules>(
      `${this.apis.core.baseUrl}/api/platform/quorum/rules`,
      this.options,
    );
  }

  calculate(request: WorkflowQuorumCalculationRequest) {
    // Arithmetic over synthetic inputs only; this endpoint creates no decision or workflow evidence.
    return this.http.post<WorkflowQuorumCalculationResult>(
      `${this.apis.core.baseUrl}/api/platform/quorum/calculations`,
      request,
      this.options,
    );
  }
}
